// extracted by mini-css-extract-plugin
export default {"labelText":"StartAndEndTime_labelText__iay0H","labelDisabled":"StartAndEndTime_labelDisabled__0DTXE"};